// D28 (2026-09-10): per-contact mirror of the live-call notes in sessionStorage.
// The notes themselves live in ContactContext (callNotes). This mirror exists
// so a page refresh mid-call or mid-ACW — D27's workaround until it shipped —
// does not wipe what the agent typed. sessionStorage is per-tab and dies with
// it; nothing here is shared or persisted beyond the browser session.
const PREFIX = 'knktr.callNotes.';

export const notesKeyFor = contactId => (contactId ? PREFIX + contactId : null);

export function readNotes(key) {
  if (!key) return null;
  try { return window.sessionStorage.getItem(key); } catch { return null; }
}

export function writeNotes(key, text) {
  if (!key) return;
  try {
    if (text) window.sessionStorage.setItem(key, text);
    else window.sessionStorage.removeItem(key);
  } catch { /* storage unavailable — in-memory notes still work */ }
}

export function removeNotes(key) {
  if (!key) return;
  try { window.sessionStorage.removeItem(key); } catch { /* ignore */ }
}
